import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
/**
 * Labels are a type of **atom** that represent a `<label>` element.
 */
const Label = ({ className, ...rest }) => {
    return (_jsx("label", { className: buildClassName('skyline-text-body-2 text-darker-gray box-border', className), ...rest }));
};
export default Label;
//# sourceMappingURL=Label.js.map